import * as Util from '../util'
import * as Icons from './icons'

const resolvePath = (path) => {
  return Util.resolvePath(path);
};

const ArrowBackWhiteImage = Icons.arrow_back_white_24dp; //resolvePath("images/common/arrow_back_white_24dp.svg");
const ChevronLeftWhiteImage = Icons.chevron_left_white_24dp; //resolvePath("images/common/chevron_left_white_24dp.svg");
const ChevronRightWhiteImage = Icons.chevron_right_white_24dp; //resolvePath("images/common/chevron_right_white_24dp.svg");
const CloudBlackImage = Icons.cloud_black_24dp; //resolvePath("images/common/cloud_black_24dp.svg");
const CloudWhiteImage = Icons.cloud_white_24dp; //resolvePath("images/common/cloud_white_24dp.svg");
const CloudDownloadBlackImage = Icons.cloud_download_black_24dp; //resolvePath("images/common/cloud_download_black_24dp.svg");
const CloudDownloadWhiteImage = Icons.cloud_download_white_24dp; //resolvePath("images/common/cloud_download_white_24dp.svg");
const DeleteForeverBlackImage = Icons.delete_forever_black_24dp; //resolvePath("images/common/delete_forever_black_24dp.svg");
const DeleteForeverWhiteImage = Icons.delete_forever_white_24dp; //resolvePath("images/common/delete_forever_white_24dp.svg");
const DescriptionBlackImage = Icons.description_black_24dp; //resolvePath("images/common/description_black_24dp.svg");
const DescriptionWhiteImage = Icons.description_white_24dp; //resolvePath("images/common/description_white_24dp.svg");
const GamepadWhiteImage = Icons.gamepad_white_24dp; //resolvePath("images/common/gamepad_white_24dp.svg");
const KeyboardWhiteImage = Icons.keyboard_white_24dp; //resolvePath("images/common/keyboard_white_24dp.svg");
const AddCircleBlackImage = Icons.add_circle_outline_black_24dp; //resolvePath("images/common/add_circle_outline_black_24dp.svg");
const AddCircleWhiteImage = Icons.add_circle_outline_white_24dp; //resolvePath("images/common/add_circle_outline_white_24dp.svg");
const PlayArrowBlackImage = Icons.play_arrow_black_24dp; //resolvePath("images/common/play_arrow_black_24dp.svg");
const LoaderImage = Icons.loader;
const LinkBlackImage = Icons.link_black_24dp;
const LinkWhiteImage = Icons.link_white_24dp;
const LinkOffBlackImage = Icons.link_off_black_24dp;
const LinkOffWhiteImage = Icons.link_off_white_24dp;
const PlayArrowWhiteImage = Icons.play_arrow_white_24dp; //resolvePath("images/common/play_arrow_white_24dp.svg");
const TuneWhiteImage = Icons.tune_white_24dp; //resolvePath("images/common/tune_white_24dp.svg");
const VolumeOffBlackImage = Icons.volume_off_black_24dp; //resolvePath("images/common/volume_off_black_24dp.svg");
const WebrcadeLogoDarkImage = Icons.webrcade_logo_dark; //resolvePath("images/common/webrcade-logo-dark.svg");
const WebrcadeLogoLargeImage = Icons.webrcade_logo_large; //resolvePath("images/common/webrcade-logo-large.svg");
const SettingsRedImage = Icons.settings_red_24dp; //resolvePath("images/common/settings_red_24dp.svg");
const SettingsWhiteImage = Icons.settings_white_24dp; //resolvePath("images/common/settings_white_24dp.svg");
const SettingsAppWhiteImage = Icons.settings_applications_white_24dp;
const TelevisionWhiteImage = Icons.tv_white_24dp; //resolvePath("images/common/tv_white_24dp.svg");
const CategoryThumbImage = resolvePath("images/folder.png");
const CategoryBackgroundImage = resolvePath("images/folder-background.png");
const FeedThumbImage = resolvePath("images/feed.png");
const FeedBackgroundImage = resolvePath("images/feed-background.png");
const XboxOneDpad = resolvePath("images/common/controller/Xbox One/XboxOne_Dpad.png");
const XboxOneAButton = resolvePath("images/common/controller/Xbox One/XboxOne_A.png");
const XboxOneBButton = resolvePath("images/common/controller/Xbox One/XboxOne_B.png");
const XboxOneXButton = resolvePath("images/common/controller/Xbox One/XboxOne_X.png");
const XboxOneYButton = resolvePath("images/common/controller/Xbox One/XboxOne_Y.png");
const XboxOneLeftStick = resolvePath("images/common/controller/Xbox One/XboxOne_Left_Stick.png");
const XboxOneRightStick = resolvePath("images/common/controller/Xbox One/XboxOne_Right_Stick.png");
const XboxOneMenuButton = resolvePath("images/common/controller/Xbox One/XboxOne_Menu.png");
const XboxOneWindowsButton = resolvePath("images/common/controller/Xbox One/XboxOne_Windows.png");
const XboxOneRightBumper = resolvePath("images/common/controller/Xbox One/XboxOne_RB.png");
const XboxOneLeftBumper = resolvePath("images/common/controller/Xbox One/XboxOne_LB.png");
const XboxOneRightTrigger = resolvePath("images/common/controller/Xbox One/XboxOne_RT.png");
const XboxOneLeftTrigger = resolvePath("images/common/controller/Xbox One/XboxOne_LT.png");
const ArrowLeftKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Left_Key_Dark.png");
const ArrowRightKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Right_Key_Dark.png");
const ArrowUpKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Up_Key_Dark.png");
const ArrowDownKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Arrow_Down_Key_Dark.png");
const EnterKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Enter_Key_Dark.png");
const ShiftKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Shift_Key_Dark.png");
const ControlKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Ctrl_Key_Dark.png");
const SpaceKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Space_Key_Dark.png");
const AKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/A_Key_Dark.png");
const CKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/C_Key_Dark.png");
const DKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/D_Key_Dark.png");
const IKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/I_Key_Dark.png");
const JKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/J_Key_Dark.png");
const KKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/K_Key_Dark.png");
const LKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/L_Key_Dark.png");
const SKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/S_Key_Dark.png");
const VKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/V_Key_Dark.png");
const XKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/X_Key_Dark.png");
const ZKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Z_Key_Dark.png");
const QKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/Q_Key_Dark.png");
const WKey = resolvePath("images/common/controller/Keyboard & Mouse/Dark/W_Key_Dark.png");

export {
  AddCircleBlackImage,
  AddCircleWhiteImage,
  ArrowBackWhiteImage,
  CategoryThumbImage,
  CategoryBackgroundImage,
  ChevronLeftWhiteImage,
  ChevronRightWhiteImage,
  CloudBlackImage,
  CloudWhiteImage,
  CloudDownloadBlackImage,
  CloudDownloadWhiteImage,
  DeleteForeverBlackImage,
  DeleteForeverWhiteImage,
  DescriptionBlackImage,
  DescriptionWhiteImage,
  FeedThumbImage,
  FeedBackgroundImage,
  GamepadWhiteImage,
  KeyboardWhiteImage,
  LoaderImage,
  LinkBlackImage,
  LinkWhiteImage,
  LinkOffBlackImage,
  LinkOffWhiteImage,
  PlayArrowBlackImage,
  PlayArrowWhiteImage,
  SettingsRedImage,
  SettingsWhiteImage,
  SettingsAppWhiteImage,
  TelevisionWhiteImage,
  TuneWhiteImage,
  WebrcadeLogoDarkImage,
  WebrcadeLogoLargeImage,
  VolumeOffBlackImage,
  XboxOneAButton,
  XboxOneBButton,
  XboxOneXButton,
  XboxOneYButton,
  XboxOneDpad,
  XboxOneLeftStick,
  XboxOneRightStick,
  XboxOneMenuButton,
  XboxOneWindowsButton,
  XboxOneRightBumper,
  XboxOneLeftBumper,
  XboxOneRightTrigger,
  XboxOneLeftTrigger,
  ArrowUpKey,
  ArrowDownKey,
  ArrowLeftKey,
  ArrowRightKey,
  ControlKey,
  EnterKey,
  ShiftKey,
  SpaceKey,
  AKey,
  CKey,
  DKey,
  IKey,
  JKey,
  KKey,
  LKey,
  QKey,
  SKey,
  VKey,
  WKey,
  XKey,
  ZKey,
  resolvePath as resolveImagePath
}
